import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { InspectionProperty } from "../../../models/InspectionProperty";
import { InspectionPropertyService } from "../../../services/inspection-property.service";

@Injectable()
export class InspectionPropertiesResolver implements Resolve<Array<InspectionProperty>> {

    resolve(): Observable<Array<InspectionProperty>> {

       return this.inspectionPropertyService.getInspectionProperties();
    }

    constructor(private inspectionPropertyService: InspectionPropertyService) { }
}
